
import { View } from 'client-website-ts-library/plugins';
import { ContextItemType } from 'client-website-ts-library/types/Context';
import { FormConstructorData } from 'client-website-ts-library/types/Forms';
import { Component, Mixins } from 'vue-property-decorator';

import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Form,
  },
})
export default class LeaseAppraisal extends Mixins(View) {
  private formData: FormConstructorData | null = null;

  mounted() {
    this.formData = new FormConstructorData([
      {
        Type: ContextItemType.EnquiryTargetProfile,
        Id: 'b05e2144-079b-4b53-9f7e-9f7c1f07ddeb', // SAMANTHA
      },
    ]);
  }
}
